module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mntrelm9-221255946d8462262ccf75edf8d3aac1.jpg";